import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Carousel } from 'react-bootstrap';
import MachineTotalProduction from '../../components/charts/machines-charts/MachineTotalProduction';
import ActiveBreakTimeBarChart from '../../components/charts/machines-charts/ActiveBreakTimeBarChart';
import LazyLoadChart from '../../components/common/LazyLoadChart';
import MachimeTime from '../../components/cards/MachimeTime';
import ShiftTotalProducedChart from '../../components/charts/machine-analitycs/ShiftTotalProducedChart';
import ShiftTotalActiveBreakTime from '../../components/charts/machine-analitycs/ShiftTotalActiveBreakTime';
import axios from 'axios';
import { INFLUX_API } from '../../config/api';
import CircleProductionTvChart from '../../components/charts/TV/CircleProductionTvChart';
import getShiftStartEndTime from '../../components/charts/utils/chartUtils';

const MemoizedShiftTotalProducedChart = React.memo(ShiftTotalProducedChart);
const MemoizedShiftTotalActiveBreakTime = React.memo(ShiftTotalActiveBreakTime);

const TvDashboard = () => {
  const [currentMachineIndex, setCurrentMachineIndex] = useState(0);
  const [rightCarouselIndex, setRightCarouselIndex] = useState(0);
  const [totalProducedIndex, setTotalProducedIndex] = useState(0);
  const [circleTotalIndex, setCircleTotalIndex] = useState(0);
  const [shiftData, setShiftData] = useState({});

  const totalProductionChartRef = useRef(null); // Ref pentru graficul ECharts
  const shiftProductionChartRef = useRef(null);
  const pieChartRef = useRef(null);

  const { startTime, endTime } = getShiftStartEndTime();

  const machines = ['l75', 'dtb1250', 'l120', 'ach300', 'dhc600', 'l70'];
  const fieldsMap = {
    l75: 'ACTIVE_TIME,BREAK_TIME',
    dtb1250: 'ACTIVE_TIME,BREAK_TIME',
    l120: 'ACTIVE_TIME,BREAK_TIME',
    ach300: 'ACTIVE_TIME,BREAK_TIME'
  };
  const currentMachine = machines[currentMachineIndex];
  const currentFields = fieldsMap[currentMachine];

  useEffect(() => {
    const machineInterval = setInterval(() => {
      setCurrentMachineIndex(prevIndex => (prevIndex + 1) % machines.length);
      // setTimeout(() => {
      //   if (totalProductionChartRef.current) {
      //     console.log('TOTAL PRODUCTION CHART RESIZED after TIMEOUT');
      //     const echartsInstance =
      //       totalProductionChartRef.current.getEchartsInstance();
      //     echartsInstance.resize();
      //   }
      // }, 200)
    }, 20000);

    return () => clearInterval(machineInterval);
  }, []);

  useEffect(() => {
    const rightCarouselInterval = setInterval(() => {
      setRightCarouselIndex(prevIndex => (prevIndex + 1) % 2);
    }, 10000);

    return () => clearInterval(rightCarouselInterval);
  }, []);

  useEffect(() => {
    const carouselInterval = setInterval(() => {
      setTotalProducedIndex(prevIndex => (prevIndex + 1) % 2);
      setCircleTotalIndex(prevIndex => (prevIndex + 1) % 2);

      // if (ShiftTotalProducedChart.current) {
      //   console.log('ShiftTotalProducedChart CHART RESIZED');
      //   const echartsInstance =
      //     ShiftTotalProducedChart.current.getEchartsInstance();
      //   echartsInstance.resize();
      // }
    }, 20000);

    return () => clearInterval(carouselInterval);
  }, []);

  useEffect(() => {
    const fetchShiftData = async () => {
      const now = new Date();
      const startOfMonth = new Date(
        now.getFullYear(),
        now.getMonth(),
        1,
        17,
        0,
        0
      );
      const endOfMonth = new Date(
        now.getFullYear(),
        now.getMonth() + 1,
        0,
        17,
        0,
        0
      );

      const requestData = {
        shiftComparisons: {
          totalProduced: true,
          activeBreakTime: true
        },
        startDateTime: startOfMonth.toISOString(),
        endDateTime: endOfMonth.toISOString()
      };

      try {
        const response = await axios.post(
          `${INFLUX_API}/api/influx/metrics`,
          requestData
        );
        setShiftData(response.data);
      } catch (error) {
        console.error('Error fetching shift data:', error);
      }
    };

    fetchShiftData();
    const hourInterval = setInterval(fetchShiftData, 3600000);
    return () => clearInterval(hourInterval);
  }, []);

  return (
    <div
      style={{
        height: '100vh',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {/* Row 1 */}
      <Row className="g-3" style={{ flex: '0 0 50%' }}>
        <Col
          xs={6}
          className="d-flex align-items-center justify-content-center"
        >
          <Carousel
            activeIndex={currentMachineIndex}
            controls={false}
            indicators={false}
            className="w-100 h-100"
            onSlid={() => {
              if (totalProductionChartRef.current) {
                console.log('Resizing chart after slide');
                totalProductionChartRef.current.resize();
              }
            }}
          >
            {machines.map(machine => (
              <Carousel.Item key={machine} className="h-100">
                <MachineTotalProduction
                  ref={totalProductionChartRef}
                  bucket="machine_data"
                  machineName={machine}
                  startTime={startTime}
                  endTime={endTime}
                  title={`Total Meter Produced On Time - ${machine.toUpperCase()}`}
                />
              </Carousel.Item>
            ))}
          </Carousel>
        </Col>

        <Col
          xs={6}
          className="d-flex align-items-center justify-content-center"
        >
          <Carousel
            activeIndex={rightCarouselIndex}
            controls={false}
            indicators={false}
            className="w-100 h-100"
          >
            <Carousel.Item>
              <Row className="h-100">
                <Col xs={6}>
                  <LazyLoadChart>
                    <MachimeTime
                      key={`totalActiveTime-${currentMachine}`}
                      time="totalActiveTime"
                      bucket="machine_data"
                      machineName={currentMachine}
                      startTime={startTime}
                      endTime={endTime}
                    />
                  </LazyLoadChart>
                </Col>
                <Col xs={6}>
                  <LazyLoadChart>
                    <MachimeTime
                      key={`totalBreakTime-${currentMachine}`}
                      time="totalBreakTime"
                      bucket="machine_data"
                      machineName={currentMachine}
                      startTime={startTime}
                      endTime={endTime}
                    />
                  </LazyLoadChart>
                </Col>
              </Row>
            </Carousel.Item>
            <Carousel.Item>
              <LazyLoadChart>
                <ActiveBreakTimeBarChart
                  key={`activeBreakTime-${currentMachine}`}
                  bucket="machine_data_30minute"
                  machineName={currentMachine}
                  fields={currentFields}
                  startTime={startTime}
                  endTime={endTime}
                  title={`Active Break Time - ${currentMachine.toUpperCase()}`}
                />
              </LazyLoadChart>
            </Carousel.Item>
          </Carousel>
        </Col>
      </Row>

      {/* Row 2 */}
      <Row className="g-3" style={{ flex: '0 0 50%' }}>
        <Col xs={6}>
          <Carousel
            activeIndex={totalProducedIndex}
            controls={false}
            indicators={false}
            className="w-100 h-100"
          >
            <Carousel.Item>
              <MemoizedShiftTotalProducedChart
                ref={shiftProductionChartRef}
                shiftData={shiftData.totalProduced}
                title="TOTAL PRODUCED ON SHIFT"
              />
            </Carousel.Item>
            <Carousel.Item>
              <MemoizedShiftTotalActiveBreakTime
                ref={shiftProductionChartRef}
                shiftData={shiftData.activeBreakTime}
                title="TOTAL BREAKS ON SHIFT"
              />
            </Carousel.Item>
          </Carousel>
        </Col>
        <Col xs={6}>
          <Carousel
            activeIndex={circleTotalIndex}
            controls={false}
            indicators={false}
            className="w-100 h-100"
          >
            <Carousel.Item>
              <CircleProductionTvChart ref={pieChartRef} />
            </Carousel.Item>
            <Carousel.Item>
              <CircleProductionTvChart ref={pieChartRef} />
            </Carousel.Item>
          </Carousel>
        </Col>
      </Row>
    </div>
  );
};

export default TvDashboard;
